import React from 'react'
import AccessibeIcon from '../icons/accessible.svg'
import AccommodationIcon from '../icons/accommodation.svg'
import CampsiteIcon from '../icons/campsite.svg'
import CostIcon from '../icons/euro.svg'
import DrinkingwaterIcon from '../icons/drinking_water.svg'
import EmailIcon from '../icons/email.svg'
import FacebookIcon from '../icons/facebook.svg'
import FoodAndDrinkIcon from '../icons/food_and_drink.svg'
import FoodIcon from '../icons/food.svg'
import HistoricIcon from '../icons/historic.svg'
import KitchenIcon from '../icons/kitchen.svg'
import PetIcon from '../icons/pet.svg'
import PhoneIcon from '../icons/phone.svg'
import RatingIcon from '../icons/star.svg'
import ShelterIcon from '../icons/shelter.svg'
import ShopIcon from '../icons/shop.svg'
import SpringIcon from '../icons/spring.svg'
import TourismIcon from '../icons/tourism.svg'
import WifiIcon from '../icons/wifi.svg'
import WebsiteIcon from '../icons/website.svg'

import {
  ACCESSIBLE,
  ACCOMMODATION,
  ACCOMMODATIONS,
  CAMPSITE,
  CAMPSITES,
  COST,
  DRINKING_WATER,
  DRINKING_WATERS,
  EMAIL,
  FOOD_AND_DRINK,
  FOOD_FACILITY,
  HISTORIC,
  HISTORICS,
  KITCHEN,
  PET,
  PHONE,
  RATING,
  SHELTER,
  SHELTERS,
  SHOP,
  SHOPS,
  SPRING,
  SPRINGS,
  TOURISM,
  TOURISMS,
  WEBSITE
} from '../trans'

export const ICON_MAPPING = {
  accessible: AccessibeIcon,
  accommodation: AccommodationIcon,
  campsite: CampsiteIcon,
  cost: CostIcon,
  drinking_water: DrinkingwaterIcon,
  email: EmailIcon,
  facebook : FacebookIcon,
  food_and_drink: FoodAndDrinkIcon,
  food_facility: FoodIcon,
  historic: HistoricIcon,
  kitchen: KitchenIcon,
  pet: PetIcon,
  phone: PhoneIcon,
  rating: RatingIcon,
  shelter: ShelterIcon,
  shop: ShopIcon,
  spring: SpringIcon,
  tourism: TourismIcon,
  wifi: WifiIcon,
  website: WebsiteIcon,
}

export const TEXT_MAPPING = {
  accessible:ACCESSIBLE,
  accommodation:ACCOMMODATION,
  campsite:CAMPSITE,
  cost:COST,
  drinking_water:DRINKING_WATER,
  email: EMAIL,
  facebook : 'facebook',
  food_and_drink:FOOD_AND_DRINK,
  food_facility:FOOD_FACILITY,
  historic:HISTORIC,
  kitchen:KITCHEN,
  pet:PET,
  phone: PHONE,
  rating:RATING,
  shelter:SHELTER,
  shop:SHOP,
  spring:SPRING,
  tourism:TOURISM,
  wifi: 'wi-fi',
  website: WEBSITE,
}

export const TEXT_MAPPING_PLURAL = {
  accessible:ACCESSIBLE,
  accommodation:ACCOMMODATIONS,
  campsite:CAMPSITES,
  cost:COST,
  drinking_water:DRINKING_WATERS,
  email: EMAIL,
  facebook : 'facebook',
  food_and_drink:FOOD_AND_DRINK,
  food_facility:FOOD_FACILITY,
  historic:HISTORICS,
  kitchen:KITCHEN,
  pet:PET,
  phone: PHONE,
  rating:RATING,
  shelter:SHELTERS,
  shop:SHOPS,
  spring:SPRINGS,
  tourism:TOURISMS,
  wifi: 'wi-fi',
  website: WEBSITE,
}


export const Icon = (props) => {
  const {icon, title, inlineText=false, text=false} = props
  const svg = ICON_MAPPING[icon]
  const icontitle = title || TEXT_MAPPING[icon]

  if (!svg) return null
    
  const componet = svg({title:icontitle})

  if (text && icontitle){
    return (
      <>{componet} {icontitle}</>
    ) 
  }
    
  if (inlineText && icontitle) {
    return (
      <>{componet}&nbsp;{icontitle}</>
    ) 
  } else {
    return componet
  }
}

export const IconList = (props) => {
    const { icons, className='', inlineText=false, text=false } = props
    const list = []

    for (const item of icons) {
      const icon = Icon({icon:item, inlineText: inlineText, text: text})
      if (icon) {
        list.push((
          <li key={item}>
            {icon}
          </li>
        ))
      }
    }

    if (!list.length) {
      return null
    }

    return (
      <ul className={ className }>
          {list}
      </ul>
    )
}
